function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.917 16.25H2.5a.833.833 0 01-.833-.833V4.376a.208.208 0 01.207-.21h16.251a.208.208 0 01.208.209V8.75a.833.833 0 001.667 0V2.5A2.5 2.5 0 0017.5 0h-15A2.5 2.5 0 000 2.5v12.917a2.5 2.5 0 002.5 2.5h5.417a.833.833 0 000-1.667z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.417 10.833A4.583 4.583 0 1020 15.417a4.583 4.583 0 00-4.583-4.584zm2.763 3.37l-2.682 3.731a.818.818 0 01-.593.335.84.84 0 01-.065.003.815.815 0 01-.573-.238l-1.53-1.529a.81.81 0 011.148-1.147l.854.855 2.125-2.958a.811.811 0 011.316.948z",
  fill: "#bfdd9b"
});

function SvgAppSynced(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "appSynced.ea748.svg";
export { SvgAppSynced as ReactComponent };